import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import { makeStyles } from '@material-ui/core/styles';
import Layout from '../components/Layout';
import Carousel from "react-bootstrap/Carousel";
import { Link } from '@reach/router';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: '-webkit-center',
    color: theme.palette.text.secondary,
  }
}));

export const IndexPageTemplate = (props) => {
  const {
    main,
    intro,
    image
  } = props;
  const classes = useStyles();
  return (
    <div style={{
      backgroundImage: 'linear-gradient( to right, #0093E9 0%, #80D0C7 100%)',
    }}>
      <div style={{ backgroundImage: 'linear-gradient(to right,  #0093E9 0%, #80D0C7 100%)',
      }}>
        <div style={{
          width: '15em',
          height: '13em',
          marginLeft: 'auto',
          marginRight: 'auto',
          }}>
          <Img
              fluid={image?.childImageSharp.fluid}
              alt='Logo'
          />
        </div>
        <Carousel >
          { main?.image1.active? <Carousel.Item style={{ width: '100vw'}} >
            <Link to={main?.image1.url}>
              <Img
                fluid={main?.image1.image.childImageSharp.fluid}
                alt={main?.image1.alt}
              />
              <Carousel.Caption>
                <h3>{main?.image1.title}</h3>
                <p>{main?.image1.alt}</p>
              </Carousel.Caption>
            </Link>
          </Carousel.Item>:null}
          {main?.image2.active? <Carousel.Item style={{ width: '100vw'}}>
            {/* TODO: Need something to determine internal vs. external link based on https:// in url or something */}
          <a href={main?.image2.url}> 
            <Img
                fluid={main?.image2.image.childImageSharp.fluid}
                alt={main?.image2.alt}
              />
              <Carousel.Caption>
                <h3>{main?.image2.title}</h3>
                <p>{main?.image2.alt}</p>
              </Carousel.Caption>
            </a> 
          </Carousel.Item>:null}
          {main?.image3.active? <Carousel.Item style={{ width: '100vw'}}>
          <Link to={main?.image3.url}>
          <Img
                fluid={main?.image3.image.childImageSharp.fluid}
                alt={main?.image3.alt}
              />
              <Carousel.Caption>
                <h3>{main?.image3.title}</h3>
                <p>{main?.image3.alt}</p>
              </Carousel.Caption>
            </Link>
          </Carousel.Item>:null}
          {main?.image4.active? <Carousel.Item style={{ width: '100vw'}}>
            <Link to={main?.image4.url}>
            <Img
                fluid={main?.image4.image.childImageSharp.fluid}
                alt={main?.image4.alt}
              />
              <Carousel.Caption>
                <h3>{main?.image4.title}</h3>
                <p>{main?.image4.alt}</p>
              </Carousel.Caption>
            </Link>
          </Carousel.Item>:null}
          {main?.image5.active? <Carousel.Item style={{ width: '100vw'}}>
            <Link to={main?.image5.url}>
            <Img
                fluid={main?.image5.image.childImageSharp.fluid}
                alt={main?.image5.alt}
              />
              <Carousel.Caption>
                <h3>{main?.image5.title}</h3>
                <p>{main?.image5.alt}</p>
              </Carousel.Caption>
            </Link>
          </Carousel.Item>: null}
        </Carousel>
      </div>
    </div>
  )
}

IndexPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  mainpitch: PropTypes.object,
  description: PropTypes.string,
  intro: PropTypes.shape({
    blurbs: PropTypes.array,
  }),
}

const IndexPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark

  return (
    <Layout>
      <IndexPageTemplate
        image={frontmatter.image}
        title={frontmatter.title}
        mainpitch={frontmatter.mainpitch}
        description={frontmatter.description}
        intro={frontmatter.intro}
      />
    </Layout>
  )
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default IndexPage

export const pageQuery = graphql`
  query IndexPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "landing-page" } }) {
      frontmatter {
        title
        image {
          childImageSharp {
            fluid(maxWidth: 2048, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        mainpitch {
          title
          description
        }
        description
        intro {
          blurbs {
            image {
              childImageSharp {
                fluid(maxWidth: 480, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            text
          }
          heading
          description
        }
      }
    }
  }
`
